"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { SeasonalRow } from "./SeasonalChart.impl";

export const SeasonalChart = dynamicChart(
  () => import("./SeasonalChart.impl").then((m) => m.SeasonalChart),
  288,
);
